import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

import MainHero from './MainHero.jsx';
import MainComparison from './MainComparison.jsx';
import MainBenefits from './MainBenefits.jsx';
import MainProcess from './MainProcess.jsx';
import MainInspection from './MainInspection.jsx';
import MainCTA from './MainCTA.jsx';

export default function Main() {
  return (
    <React.Fragment>
      <MainHero />
      <MainComparison />
      <MainBenefits />
      <MainProcess />
      <MainInspection />
      <MainCTA />
    </React.Fragment>
  );
}